const items = document.querySelectorAll(".how__choose__item");
const block = document.querySelector(".how__choose__block");

if (items.length > 4 && block) {
    block.classList.add("how__choose__block_card");
}